import React, { useEffect, useState } from 'react';
import api from '../services/api';
import Button from '../common/Button';
import Spinner from '../common/Spinner';

const PaymentApproval = ({ tripId, plateNumber }) => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchPayments = () => {
    setLoading(true);
    api.get(`/mashell/payments/${tripId}`)
      .then(res => setPayments(res.data))
      .catch(() => setError('Could not load pending payments'))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchPayments();
  }, [tripId]);

  const handleApprove = async (paymentId) => {
    try {
      await api.post('/mashell/approve', { payment_id: paymentId });
      fetchPayments(); // refresh list
    } catch (err) {
      alert('Approval failed: ' + (err.response?.data?.error || 'Error'));
    }
  };

  const handleReject = async (paymentId) => {
    try {
      await api.post('/mashell/reject', { payment_id: paymentId });
      fetchPayments();
    } catch (err) {
      alert('Rejection failed: ' + (err.response?.data?.error || 'Error'));
    }
  };

  if (loading) return <Spinner />;

  return (
    <div className="glass-card fade-in">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <h2>Pending Payments</h2>
        {plateNumber && <span className="vehicle-badge">🚌 {plateNumber}</span>}
      </div>
      {error && <div className="error-message">{error}</div>}
      {payments.length === 0 ? (
        <p>No pending payments for this trip.</p>
      ) : (
        <ul className="payment-list">
          {payments.map(p => (
            <li key={p.id} className="payment-item">
              <div className="passenger-info">
                <strong>{p.passenger_name}</strong>
                <span className="amount">${p.amount}</span>
              </div>
              <div className="actions">
                <Button variant="success" onClick={() => handleApprove(p.id)}>
                  ✓ Approve
                </Button>
                <Button variant="danger" onClick={() => handleReject(p.id)}>
                  ✗ Reject
                </Button>
              </div>
            </li>
          ))}
        </ul>
      )}
      <style>{`
        .vehicle-badge {
          background: var(--primary-light);
          color: var(--primary);
          padding: 0.25rem 1rem;
          border-radius: 20px;
          font-weight: 600;
        }
        .payment-list { list-style: none; }
        .payment-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1.25rem;
          background: white;
          margin-bottom: 0.75rem;
          border-radius: var(--radius-md);
          box-shadow: var(--shadow-sm);
          transition: var(--transition);
        }
        .payment-item:hover {
          box-shadow: var(--shadow-md);
        }
        .passenger-info {
          display: flex;
          gap: 1.5rem;
          align-items: center;
        }
        .amount {
          font-weight: 700;
          color: var(--primary);
          font-size: 1.1rem;
        }
        .actions {
          display: flex;
          gap: 0.75rem;
        }
      `}</style>
    </div>
  );
};

export default PaymentApproval;